module.exports = __webpack_public_path__ + "assets/img/8_1752.1cd5d00f.jpg";